// src/constants/media.js
import { CDN } from '@/config/cdn'

// Icons / UI
export const ICONS = {
  play:  CDN.icons('play-icon.svg'),
  hot:   CDN.icons('hotgames.png'),
  new:   CDN.icons('newgames-icon.svg'),
  globe: CDN.icons('icon_globe.png'),
}

// Logos / shared art
export const LOGOS = {
  mossbets:        CDN.images('mossbets-logo.png'),
  mossbetsReverse: CDN.images('mossbets-logo-reverse.png'),
  adsBanner:       CDN.images('adsbanners.png'),
  favicon:         CDN.images('favicon.png'),
}

// Hero banners (as in the HTML designs)
export const BANNERS = {
  horseRacing: CDN.images('horseracingbanner.jpg'),
  turbo:       CDN.images('turbobanner.jpg'),
}
export const HERO_SLIDES = [
  CDN.images('horseracingbanner.jpg'),
  CDN.images('turbobanner.jpg'),
  CDN.images('horseracingbanner.jpg'),
  CDN.images('turbobanner.jpg'),
]

// Live-casino vertical banners
export const LIVE_CASINO_R = {
  r1: CDN.images('r-casino-game1.png'),
  r2: CDN.images('r-casino-game2.png'),
  r3: CDN.images('r-casino-game3.png'),
  r4: CDN.images('r-casino-game4.png'),
}

// Virtual section thumbnails (match filenames from your design)
export const VIRTUAL = {
  vlThumb:        CDN.images('vl-thumbnail.png'),
  vtlThumb:       CDN.images('vtl-thumbnail.png'),
  crashThumb:     CDN.images('crash-thumbnail.png'),
  virtualRacing:  CDN.images('virtual-racing.png'),
  klThumb:        CDN.images('kl-thumbnail.png'),
  boxThumb:       CDN.images('box-thumbnail.png'),
  vtThumb:        CDN.images('vt-thumbnail.png'),
  vjThumb:        CDN.images('vj-thumbnail.png'),
}

// Crash section images
export const CRASH = {
  aviator:  CDN.images('aviator.jpg'),
  aviatrix: CDN.images('aviatrix.jpg'),
}

// Casino / slot thumbnails
export const CASINO = {
  fourHorsemen: CDN.images('4HorsemenIII.webp'),
  bigBass:      CDN.images('BigBassBonanza.webp'),
  dracula:      CDN.images('DraculasCrypt.webp'),
  jokerQueen:   CDN.images('JokerQueen.webp'),
  legacyDead:   CDN.images('LegacyofDead.webp'),
  casino1:      CDN.images('casinogame-1.svg'),
  casino2:      CDN.images('casinogame-2.svg'),
}

// Country flags
export const COUNTRIES = {
  england: CDN.countries('121-england.png'),
  spain:   CDN.countries('230-spain.png'),
  germany: CDN.countries('208-germany.png'),
  italy:   CDN.countries('263-italy.png'),
  france:  CDN.countries('197-france.png'),
  kenya:   CDN.countries('234-kenya.png'),
}

// DRY game lists reused across pages
export const GAMES = {
  virtualKiron: [
    { title: 'Aztec Magic', img: VIRTUAL.vlThumb,       badge: 'hot' },
    { title: 'Aztec Magic', img: VIRTUAL.vtlThumb,      badge: 'hot' },
    { title: 'Aztec Magic', img: VIRTUAL.crashThumb },
    { title: 'Aztec Magic', img: VIRTUAL.virtualRacing, badge: 'new' },
    { title: 'Aztec Magic', img: VIRTUAL.klThumb },
    { title: 'Aztec Magic', img: VIRTUAL.boxThumb,      badge: 'hot' },
    { title: 'Aztec Magic', img: VIRTUAL.vtThumb },
    { title: 'Aztec Magic', img: VIRTUAL.vjThumb,       badge: 'hot' },
    { title: 'Aztec Magic', img: VIRTUAL.vlThumb,       badge: 'hot' },
    { title: 'Aztec Magic', img: VIRTUAL.vtlThumb,      badge: 'hot' },
  ],

  crashHot: [
    { title: 'Aztec Magic', img: CRASH.aviator,       badge: 'hot' },
    { title: 'Aztec Magic', img: CRASH.aviatrix,      badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.dracula },
    { title: 'Aztec Magic', img: CASINO.jokerQueen,   badge: 'new' },
    { title: 'Aztec Magic', img: CASINO.legacyDead },
    { title: 'Aztec Magic', img: CASINO.fourHorsemen, badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.casino1,      badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.casino2,      badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.fourHorsemen, badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.jokerQueen,   badge: 'new' },
  ],

  instantHot: [
    { title: 'Aztec Magic', img: CASINO.fourHorsemen, badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.bigBass,      badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.dracula },
    { title: 'Aztec Magic', img: CASINO.jokerQueen,   badge: 'new' },
    { title: 'Aztec Magic', img: CASINO.legacyDead },
    { title: 'Aztec Magic', img: CASINO.fourHorsemen, badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.casino1,      badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.casino2,      badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.fourHorsemen, badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.jokerQueen,   badge: 'new' },
  ],

  instantKiron: [
    { title: 'Aztec Magic', img: VIRTUAL.vlThumb,       badge: 'hot' },
    { title: 'Aztec Magic', img: VIRTUAL.vtlThumb,      badge: 'hot' },
    { title: 'Aztec Magic', img: VIRTUAL.crashThumb },
    { title: 'Aztec Magic', img: VIRTUAL.virtualRacing, badge: 'new' },
    { title: 'Aztec Magic', img: VIRTUAL.klThumb },
    { title: 'Aztec Magic', img: VIRTUAL.boxThumb,      badge: 'hot' },
    { title: 'Aztec Magic', img: VIRTUAL.vtThumb },
    { title: 'Aztec Magic', img: VIRTUAL.vjThumb,       badge: 'hot' },
    { title: 'Aztec Magic', img: VIRTUAL.vlThumb,       badge: 'hot' },
    { title: 'Aztec Magic', img: VIRTUAL.vtlThumb,      badge: 'hot' },
  ],

  casinoHot: [
    { title: 'Aztec Magic', img: CASINO.fourHorsemen, badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.bigBass,      badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.dracula },
    { title: 'Aztec Magic', img: CASINO.jokerQueen,   badge: 'new' },
    { title: 'Aztec Magic', img: CASINO.legacyDead },
    { title: 'Aztec Magic', img: CASINO.fourHorsemen, badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.casino1,      badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.casino2,      badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.fourHorsemen, badge: 'hot' },
    { title: 'Aztec Magic', img: CASINO.jokerQueen,   badge: 'new' },
  ],
}
